class DetailSkill {
    constructor(_tab){
        this.tab = _tab;
    }

    getTempl(_newVal){
        return /*html*/`
        <span class="gd-search-detail-tag">스킬 <span>DB</span></span>
        ${this.secHeaderTmpl(_newVal)}
        ${this.secOtionTmpl(_newVal)}
        ${this.secDescTmpl(_newVal)}
        ${this.secNeedTmpl(_newVal)}
        ${this.secUseClassTmpl(_newVal)}
        <div class="gd-search-detail-content"><p class="gd-sub-info-paragraph">캐릭터의 상태에 따라 게임 내에 표시되는 수치와 차이가 있을 수 있습니다.</p></div>`;
    }

    secHeaderTmpl(it){
        return /*html*/`
        <div class="gd-search-detail-content">
            <div class="gd-detail-main">
                <span class="gd-detail-main-thumb"><img src="${it.image}" alt="${it.name.replace(/</g,'&lt;').replace(/>/g,'&gt;')}" width="60" height="60" onerror="this.src='https://assets.playnccdn.com/plaync/gamedictionary/v1/img/default.png';"></span>
                <div class="gd-detail-main-text-wrap">
                    <span class="gd-detail-main-text">${it.name.replace(/</g,'&lt;').replace(/>/g,'&gt;')}</span>
                    <span class="gd-detail-sub-text">${[it.operateTypeName, it.iconTypeName].filter(tem=>!!tem).join(' / ')}</span>
                </div>
            </div>
            <div class="gd-detail-level-wrap">
                <span class="gd-detail-level-text">스킬 레벨</span>
                <div class="gd-detail-level">
                    <label>${this.levelRange(it)}</label>
                </div>
            </div>
        </div>`;
    }

    levelRange(it){
        let leng = it.levelRange.maxLevel - it.levelRange.minLevel + 1;
        let list = [];
        for (let i = 0; i < leng; i++) {
            let isSel = '';
            if(it.level === (it.levelRange.minLevel+i)) isSel = ' selected="selected"';
            list.push( `<option value="${it.levelRange.minLevel+i}"${isSel}>Lv ${it.levelRange.minLevel+i}</option>` );
        }
        return `<select class="gd-detail-select" ${leng<=1?' disabled':''}>${list.join('')}</select>`;
    }

    secOtionTmpl(it){
        if(!it.mpConsume && !it.hpConsume && (it.castRange<1) && !it.reuseDelay && !it.skillPrepareTime && !it.automaticUse) return '';

        return /*html*/`
        <div class="gd-search-detail-content">
            <ul class="gd-detail-textinfo-list">
                ${it.mpConsume? `<li>소모MP : <em>${it.mpConsume}</em></li>`: ``}
                ${it.hpConsume? `<li>소모HP : <em>${it.hpConsume}</em></li>`: ``}
                ${it.bpConsume? `<li>소모BP : <em>${it.bpConsume}</em></li>`: ``}
                ${it.dpConsume? `<li>소모DP : <em>${it.dpConsume}</em></li>`: ``}

                ${(it.itemConsume && it.itemConsume.length)? `<li>소모 아이템 : ${it.itemConsume.map(item =>  `<em>${item.name}</em> ${item.count}개` ).join(', ')}</li>`: ``}

                ${(it.castRange && it.castRange>0 && it.castRange<1301)? `<li>유효거리 : <em>${it.castRange}</em></li>`: ``}
                ${it.reuseDelay? `<li>재사용 시간 : <em>${it.reuseDelay}초</em></li>`: ``}
                ${it.skillPrepareTime? `<li>시전 시간 : <em>${it.skillPrepareTime}초</em></li>`: ``}

                ${it.abnormalTime? `<li>지속 시간 : <em>${it.abnormalTime}초</em></li>`: ``}
                ${it.targetType? `<li>타겟 정보 : <em>${it.targetType}</em></li>`: ``}
                ${it.affectScope? `<li>적용 대상 : <em>${it.affectScope}</em></li>`: ``}
                ${it.attackItemType? `<li>장비 조건 : <em>${it.attackItemType}</em></li>`: ``}

                ${it.automaticUse? `<li>자동 사용 : <em>가능</em></li>`: ``}
            </ul>
        </div>`;
    }

    secDescTmpl(it){
        if(!it.description) return '';
        return /*html*/`
        <div class="gd-search-detail-content">
            <p class="gd-detail-info-paragraph">${it.description.replace(/\\n/g,'<br />')}</p>
        </div>`;
    }

    secNeedTmpl(it){
        let rareClass = (this.tab=='lineage2Awakening')? `rare-`: 'rare-lineage2-1 rare-lineage2-';
        let needList = '';
        if (it.itemNeeded && it.itemNeeded.length>0) {
            needList = /*html*/`
            <li class="needlist">필요 아이템 : ${
                it.itemNeeded.map(item=>{
                    return `<button class="${rareClass}${item.nameClass}" data-id="${item.id}" data-name="${item.name}" data-image="${item.image}">${item.name.replace(/</g,'&lt;').replace(/>/g,'&gt;')}<em> : ${item.count}</em></button>`;
                }).join(', ')
            }</li>`;
        }

        return /*html*/`
        <div class="gd-search-detail-content">
            <strong class="gd-bold-text">배우기 조건</strong>
            <ul class="gd-detail-textinfo-list">
                ${it.getLevel? `<li>캐릭터 Lv : ${it.getLevel}</li>`: ``}
                <li>필요 SP : ${it.levelUpSp}</li>
                ${needList}
            </ul>
        </div>`;
    }

    secUseClassTmpl(it){
        if(!it.class) return '';
        
        return /*html*/`
        <div class="gd-search-detail-content">
            <strong class="gd-bold-text">사용 클래스</strong>
            <ul class="gd-detail-textinfo-list">
                ${it.class.map( item=>`<li><em>${item.name}</em></li>`).join('')}
            </ul>
        </div>`;
    }
} // end of class
export default DetailSkill;